import { useQuery } from "@tanstack/react-query";
import { ProductMainCategory } from "../types";
import { get } from "../services/restClient";
import { Endpoint, setEndpoint } from "../services/endpoints";
import { queryClient } from "./queryClient";

const ProductMainCategoryKeys = {
    all: ["productMainCategories"] as const,
    lists: () => [...ProductMainCategoryKeys.all, "list"] as const,
    list: (filters: string) => [...ProductMainCategoryKeys.lists(), { filters }] as const,
    details: () => [...ProductMainCategoryKeys.all, "detail"] as const,
    detail: (id: string) => [...ProductMainCategoryKeys.details(), id] as const,
};

const getProductMainCategories = async () => {
    const data = await get<ProductMainCategory[]>(setEndpoint(Endpoint.mainCategories), {
        requireAuth: true,
    });
    return data;
};

export const useGetProductMainCategories = () => {
    return useQuery({
        queryKey: ["productMainCategories"],
        queryFn: () => getProductMainCategories(),
    });
};

export const prefetchProductMainCategories = () => {
    return queryClient.prefetchQuery({
        queryKey: ["productMainCategories"],
        queryFn: () => getProductMainCategories(),
    });
};
